import './head.less';

require('./auth/auth');
require('./basket/basket');
require('./catalog-menu/catalog-menu');
require('./geo/geo');
require('./search/search');
require('./scroll-header/scroll-header');
require('./page-scroll/page-scroll');
require('./rst/rst');

import { openOldCart } from './../content/old-cart/old-cart.js';

$(document).ready(function () {
    $(document).on('click', '.current-car', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $('.garage-modal').removeClass('open');
        } else {
            $(this).addClass('active');
            $('.garage-modal').addClass('open');
        }
    });

    $(document).mouseup(function (e) {
        var container = $('.garage-modal');

        if (
            !container.is(e.target) &&
            container.has(e.target).length === 0 &&
            !$('.current-car, .header-car--name, .header-car--vin').is(e.target)
        ) {
            container.removeClass('open');
            $('.current-car').removeClass('active');
        }
    });

    $(document).on('mouseup', '.garage-link', function () {
        $('.garage-modal').removeClass('open');
        $('.current-car').removeClass('active');
    });

    if (
        typeof window.localStorage !== 'undefined' &&
        sessionStorage.getItem('isLoad') == null
    ) {
        sessionStorage.setItem('isLoad', '1');
        $('.header-car').addClass('first-load');
    }

    if ($('#oldCart').length == 1) {
        openOldCart();
    }

    $('.menu-dropdown').on('click', function () {
        $(this).find('ul').toggle();
    });

    $(document).mouseup(function (e) {
        var container = $('.menu-dropdown');

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.menu-dropdown ul').hide();
        }
    });

    $('.user_report_btn').fancybox({ type: 'ajax' });
});
